import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { translations } from '../../../../locales/translations';
import { DisplayFieldHorizontal } from './DisplayFieldHorizontal';
import { useSelector } from 'react-redux';
import { selectCurrency, selectDeposit, selectDepositView, selectPreviewMode } from '../slice/selectors';
import { Grid } from '@material-ui/core';
import { LoadingIndicator } from '../../../components/LoadingIndicator';
import { selectContractStatus } from '../../WorkListPage/slice/selectors';

export function DepositItems() {
  const depositData = useSelector(selectDeposit);
  const previewMode = useSelector(selectPreviewMode);
  const depositView = useSelector(selectDepositView);
  const [displayData, setDisplayData] = useState(depositData);
  const [highlightChange, setHighlightChange] = useState(false);
  const currency = useSelector(selectCurrency);
  const contractStatus = useSelector(selectContractStatus);

  React.useEffect(() => {
    if (previewMode && depositView) {
      setHighlightChange(true);
      setDisplayData(depositView);
    } else {
      setDisplayData(depositData);
    }

    if(contractStatus![`depositStatus`] === 'Auto'){
      setHighlightChange(false);
    }
  }, [previewMode]);

  React.useEffect(() => {
    if (!previewMode) {
      setDisplayData(depositData);
    } else if (depositView) {
      setDisplayData(depositView);
    }
  }, [depositData]);

  return (
    <Wrapper>
      {displayData && depositData ? (
        <div>
          <Grid container className='deposit-container'>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                value={`${currency} ${displayData.previousDeposit.toLocaleString(
                  undefined,
                  { maximumFractionDigits: 2 },
                )}`}
                label={translations.contractDetail.previousDeposit}
                displayChange={highlightChange && displayData.previousDeposit !== depositData.previousDeposit}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                value={`${currency} ${displayData.currentDeposit.toLocaleString(
                  undefined,
                  { maximumFractionDigits: 2 },
                )}`}
                label={translations.contractDetail.currentDeposit}
                displayChange={highlightChange && displayData.currentDeposit !== depositData.currentDeposit}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                value={`${currency} ${displayData.netDeposit.toLocaleString(
                  undefined,
                  { maximumFractionDigits: 2 },
                )}`}
                label={translations.contractDetail.netDeposit}
                displayChange={highlightChange && displayData.netDeposit !== depositData.netDeposit}
              />
            </Grid>
          </Grid>
          <Grid container className='deposit-container'>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                value={displayData.poNumber}
                label={translations.contractDetail.poNumber}
                displayChange={highlightChange && displayData.poNumber !== depositData.poNumber}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                value={displayData.paymentTerms}
                label={translations.contractDetail.paymentTerms}
                displayChange={highlightChange && displayData.paymentTerms !== depositData.paymentTerms}
              />
            </Grid>
          </Grid>
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${p => p.theme.containerBackground};
  font-size: 12px;
  border-radius: 5px;

  .deposit-container {
    margin: 5px 0;
  }
`;
